/* tslint:disable */
/**
* @module SDKModule
* @author Jonathan Casarrubias <t:@johncasarrubias> <gh:jonathan-casarrubias>
* @license MIT 2016 Jonathan Casarrubias
* @version 2.1.0
* @description
* The SDKModule is a generated Software Development Kit automatically built by
* the LoopBack SDK Builder open source module.
*
* The SDKModule provides Angular 2 >= RC.5 support, which means that NgModules
* can import this Software Development Kit as follows:
*
*
* APP Route Module Context
* ============================================================================
* import { NgModule }       from '@angular/core';
* import { BrowserModule }  from '@angular/platform-browser';
* // App Root
* import { AppComponent }   from './app.component';
* // Feature Modules
* import { SDK[Browser|Node|Native]Module } from './shared/sdk/sdk.module';
* // Import Routing
* import { routing }        from './app.routing';
* @NgModule({
*  imports: [
*    BrowserModule,
*    routing,
*    SDK[Browser|Node|Native]Module.forRoot()
*  ],
*  declarations: [ AppComponent ],
*  bootstrap:    [ AppComponent ]
* })
* export class AppModule { }
*
**/
import { ErrorHandler } from './services/core/error.service';
import { LoopBackAuth } from './services/core/auth.service';
import { LoggerService } from './services/custom/logger.service';
import { SDKModels } from './services/custom/SDKModels';
import { InternalStorage, SDKStorage } from './storage/storage.swaps';
import { HttpClientModule } from '@angular/common/http';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CookieBrowser } from './storage/cookie.browser';
import { StorageBrowser } from './storage/storage.browser';
import { BrandingApi } from './services/custom/Branding';
import { ColorSettingsApi } from './services/custom/ColorSettings';
import { CustomerUrlApi } from './services/custom/CustomerUrl';
import { FormattedAddressApi } from './services/custom/FormattedAddress';
import { AnnouncementApi } from './services/custom/Announcement';
import { CategoryApi } from './services/custom/Category';
import { CheckInApi } from './services/custom/CheckIn';
import { ClientApi } from './services/custom/Client';
import { CommentApi } from './services/custom/Comment';
import { CustomerApi } from './services/custom/Customer';
import { CustomerMemoApi } from './services/custom/CustomerMemo';
import { FileRecordApi } from './services/custom/FileRecord';
import { ImportLogApi } from './services/custom/ImportLog';
import { InvitationApi } from './services/custom/Invitation';
import { NotificationPreferenceApi } from './services/custom/NotificationPreference';
import { CustomerEventApi } from './services/custom/CustomerEvent';
import { NotificationRecordApi } from './services/custom/NotificationRecord';
import { MemberApi } from './services/custom/Member';
import { MemoApi } from './services/custom/Memo';
import { MemoEventApi } from './services/custom/MemoEvent';
import { ModelEventApi } from './services/custom/ModelEvent';
import { OrganisationApi } from './services/custom/Organisation';
import { OrganisationFeedbackApi } from './services/custom/OrganisationFeedback';
import { OrganisationPreferenceApi } from './services/custom/OrganisationPreference';
import { PermissionRequestApi } from './services/custom/PermissionRequest';
import { CategoriesApi } from './services/custom/Categories';
import { CustomersApi } from './services/custom/Customers';
import { CustomerProfileApi } from './services/custom/CustomerProfile';
import { FilesApi } from './services/custom/Files';
import { MemosApi } from './services/custom/Memos';
import { OrganisationsApi } from './services/custom/Organisations';
import { AnnouncementRequestApi } from './services/custom/AnnouncementRequest';
import { AnnouncementUpdateRequestApi } from './services/custom/AnnouncementUpdateRequest';
import { CategoryRequestApi } from './services/custom/CategoryRequest';
import { CheckInRequestApi } from './services/custom/CheckInRequest';
import { CommentRequestApi } from './services/custom/CommentRequest';
import { CustomerRequestApi } from './services/custom/CustomerRequest';
import { CustomerSettingApi } from './services/custom/CustomerSetting';
import { DeviceRequestApi } from './services/custom/DeviceRequest';
import { FileTokenApi } from './services/custom/FileToken';
import { InvitationRequestApi } from './services/custom/InvitationRequest';
import { MemberRequestApi } from './services/custom/MemberRequest';
import { MemoActionRequestApi } from './services/custom/MemoActionRequest';
import { MemoRequestApi } from './services/custom/MemoRequest';
import { MemoStatsRequestApi } from './services/custom/MemoStatsRequest';
import { NotificationPreferencesRequestApi } from './services/custom/NotificationPreferencesRequest';
import { OrganisationCategorySettingsRequestApi } from './services/custom/OrganisationCategorySettingsRequest';
import { OrganisationRequestApi } from './services/custom/OrganisationRequest';
import { OrganisationFeedbackRequestApi } from './services/custom/OrganisationFeedbackRequest';
import { PermissionApiRequestApi } from './services/custom/PermissionApiRequest';
import { PermissionResponseRequestApi } from './services/custom/PermissionResponseRequest';
import { PushRequestApi } from './services/custom/PushRequest';
import { ResetRequestApi } from './services/custom/ResetRequest';
import { SignupRequestApi } from './services/custom/SignupRequest';
import { TentativePermissionRequestApi } from './services/custom/TentativePermissionRequest';
import { UpdateMemberDetailsRequestApi } from './services/custom/UpdateMemberDetailsRequest';
import { CommentResponseApi } from './services/custom/CommentResponse';
import { CustomerActivityResponseApi } from './services/custom/CustomerActivityResponse';
import { CustomerResponseApi } from './services/custom/CustomerResponse';
import { CustomerImportResponseApi } from './services/custom/CustomerImportResponse';
import { CustomerLimitedResponseApi } from './services/custom/CustomerLimitedResponse';
import { CustomerMinimalResponseApi } from './services/custom/CustomerMinimalResponse';
import { InvitationResponseApi } from './services/custom/InvitationResponse';
import { JsonWebTokenApi } from './services/custom/JsonWebToken';
import { MemberActivityResponseApi } from './services/custom/MemberActivityResponse';
import { MemberResponseApi } from './services/custom/MemberResponse';
import { MemoResponseApi } from './services/custom/MemoResponse';
import { MemoStatsResponseApi } from './services/custom/MemoStatsResponse';
import { OrganisationFeedItemApi } from './services/custom/OrganisationFeedItem';
import { OrganisationPreferenceRemoteApi } from './services/custom/OrganisationPreferenceRemote';
import { OrganisationResponseApi } from './services/custom/OrganisationResponse';
import { PendingInvitationResponseApi } from './services/custom/PendingInvitationResponse';
import { PermissionApiResponseApi } from './services/custom/PermissionApiResponse';
import { ProfileResponseApi } from './services/custom/ProfileResponse';
import { MigrationApi } from './services/custom/Migration';
import { MigrationMapApi } from './services/custom/MigrationMap';
/**
* @module SDKBrowserModule
* @description
* This module should be imported when building a Web Application in the following scenarios:
*
*  1.- Regular web application
*  2.- Angular universal application (Browser Portion)
*  3.- Progressive applications (Angular Mobile, Ionic, WebViews, etc)
**/
var SDKBrowserModule = /** @class */ (function () {
    function SDKBrowserModule() {
    }
    SDKBrowserModule.forRoot = function (internalStorageProvider) {
        if (internalStorageProvider === void 0) { internalStorageProvider = {
            provide: InternalStorage,
            useClass: CookieBrowser
        }; }
        return {
            ngModule: SDKBrowserModule,
            providers: [
                LoopBackAuth,
                LoggerService,
                SDKModels,
                BrandingApi,
                ColorSettingsApi,
                CustomerUrlApi,
                FormattedAddressApi,
                AnnouncementApi,
                CategoryApi,
                CheckInApi,
                ClientApi,
                CommentApi,
                CustomerApi,
                CustomerMemoApi,
                FileRecordApi,
                ImportLogApi,
                InvitationApi,
                NotificationPreferenceApi,
                CustomerEventApi,
                NotificationRecordApi,
                MemberApi,
                MemoApi,
                MemoEventApi,
                ModelEventApi,
                OrganisationApi,
                OrganisationFeedbackApi,
                OrganisationPreferenceApi,
                PermissionRequestApi,
                CategoriesApi,
                CustomersApi,
                CustomerProfileApi,
                FilesApi,
                MemosApi,
                OrganisationsApi,
                AnnouncementRequestApi,
                AnnouncementUpdateRequestApi,
                CategoryRequestApi,
                CheckInRequestApi,
                CommentRequestApi,
                CustomerRequestApi,
                CustomerSettingApi,
                DeviceRequestApi,
                FileTokenApi,
                InvitationRequestApi,
                MemberRequestApi,
                MemoActionRequestApi,
                MemoRequestApi,
                MemoStatsRequestApi,
                NotificationPreferencesRequestApi,
                OrganisationCategorySettingsRequestApi,
                OrganisationRequestApi,
                OrganisationFeedbackRequestApi,
                PermissionApiRequestApi,
                PermissionResponseRequestApi,
                PushRequestApi,
                ResetRequestApi,
                SignupRequestApi,
                TentativePermissionRequestApi,
                UpdateMemberDetailsRequestApi,
                CommentResponseApi,
                CustomerActivityResponseApi,
                CustomerResponseApi,
                CustomerImportResponseApi,
                CustomerLimitedResponseApi,
                CustomerMinimalResponseApi,
                InvitationResponseApi,
                JsonWebTokenApi,
                MemberActivityResponseApi,
                MemberResponseApi,
                MemoResponseApi,
                MemoStatsResponseApi,
                OrganisationFeedItemApi,
                OrganisationPreferenceRemoteApi,
                OrganisationResponseApi,
                PendingInvitationResponseApi,
                PermissionApiResponseApi,
                ProfileResponseApi,
                MigrationApi,
                MigrationMapApi,
                internalStorageProvider,
                { provide: SDKStorage, useClass: StorageBrowser }
            ]
        };
    };
    SDKBrowserModule.decorators = [
        { type: NgModule, args: [{
                    imports: [CommonModule, HttpClientModule],
                    declarations: [],
                    exports: [],
                    providers: [
                        ErrorHandler
                    ]
                },] },
    ];
    return SDKBrowserModule;
}());
export { SDKBrowserModule };
/**
* Have Fun!!!
* - Jon
**/
export * from './models/index';
export * from './services/index';
export * from './lb.config';
export * from './storage/storage.swaps';
export { CookieBrowser } from './storage/cookie.browser';
export { StorageBrowser } from './storage/storage.browser';
//# sourceMappingURL=index.js.map